import { addNextActions } from "@/modules/lead-page/api/lead-page.api";
import { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import { AddNextActionRequest } from "@/modules/lead-page/dtos";
import React from "react";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { toast } from "react-toastify";

const useAddNextActions = () => {
  const [description, setDescription] = useState<string>("");
  const [dateError, setDateError] = useState<string>("");

  const [addNextActionModal, setAddNextActionModal] = useState<boolean>(false);
  const [notify, setNotify] = useState<boolean>(false);

  const [date, setDate] = useState<string>(() => {
    return new Date().toISOString().slice(0, 23) + "Z";
  });
  const dateValue: Date | null = date ? new Date(date) : null;

  const addNextActionMutation = useMutation(
    (data: AddNextActionRequest) => addNextActions(data),
    {
      onSuccess: () => {
        setAddNextActionModal(false);
        setNotify(false);
        queryClient.invalidateQueries({ queryKey: ["getNextActions"] });
        toast.success("Next Action Added Successfully!", {
          position: "bottom-left",
          autoClose: 2000,
        });
      },
      onError: (error: any) => {
        setNotify(false);
        toast.error(
          error.status == 403
            ? "You are not authorized to add next action"
            : "Error Adding Next Action",
          {
            position: "bottom-left",
            autoClose: 2000,
          }
        );
      },
    }
  );

  const handleDateChange = (newValue: Date | null) => {
    setDate(newValue ? newValue.toISOString() : "");
  };

  const handleTextareaChange: React.ChangeEventHandler<HTMLTextAreaElement> = (
    e
  ) => {
    setDescription(e.target.value);
  };

  const { lead } = useContext(LeadPageContext);

  const handleSubmitNextAction = () => {
    const data = {
      actionTime: date,
      description: description,
      leadJourneyUId: lead?.data.uid,
    };
    setDescription("");
    setDate("");
    addNextActionMutation.mutate(data);
  };

  return {
    notify,
    addNextActionModal,
    dateValue,
    description,
    isError: addNextActionMutation.isError,
    isSuccess: addNextActionMutation.isSuccess,
    isloading: addNextActionMutation.isPending,
    addNextActionMutation,
    dateError,
    setDateError,
    setDate,
    setDescription,
    handleDateChange,
    setAddNextActionModal,
    handleTextareaChange,
    handleSubmitNextAction,
    setNotify,
  };
};

export default useAddNextActions;
